var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "switch_account_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "name" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("按钮名称展示为")]),
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的名称", clearable: "" },
            model: {
              value: _vm.value.config.name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "name", $$v)
              },
              expression: "value.config.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "account_sort" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("企业排列顺序")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.account_sort,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "account_sort", $$v)
                },
                expression: "value.config.account_sort",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("默认排序")]),
              _c("el-radio", { attrs: { label: 2 } }, [
                _vm._v("先加入或发卡的企业靠前展示"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "title" }, [_vm._v("按钮名称大小和颜色")]),
          _c(
            "el-form-item",
            { attrs: { label: "字号" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.switch_font_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "switch_font_size", $$v)
                  },
                  expression: "value.config.switch_font_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "颜色" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.value.config.switch_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "switch_color", $$v)
                  },
                  expression: "value.config.switch_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "title" }, [_vm._v("切换图标大小和颜色")]),
          _c(
            "el-form-item",
            { attrs: { label: "图标尺寸" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.button_font_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "button_font_size", $$v)
                  },
                  expression: "value.config.button_font_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "颜色" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.value.config.button_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "button_color", $$v)
                  },
                  expression: "value.config.button_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }